/** One block's publication switch. */
export default function VisibilitySwitch({
    label,
    hint,
    checked,
    onChange,
    disabled = false,
}: {
    label: string;
    hint?: string;
    checked: boolean;
    onChange: (value: boolean) => void;
    disabled?: boolean;
}) {
    return (
        <label
            className={`flex items-start justify-between gap-4 ${disabled ? "opacity-60" : ""}`}
        >
            <span className="flex flex-col gap-0.5">
                <span className="text-theme-sm font-medium text-content-primary">{label}</span>
                {hint && <span className="text-theme-xs text-content-tertiary">{hint}</span>}
            </span>
            <input
                type="checkbox"
                role="switch"
                checked={checked}
                disabled={disabled}
                onChange={(e) => onChange(e.target.checked)}
                className="mt-1 h-5 w-9 shrink-0 cursor-pointer appearance-none rounded-full bg-gray-200 transition-colors checked:bg-brand-500 disabled:cursor-not-allowed dark:bg-gray-700 relative before:absolute before:top-0.5 before:left-0.5 before:h-4 before:w-4 before:rounded-full before:bg-white before:transition-transform checked:before:translate-x-4 focus-visible:outline-2 focus-visible:outline-brand-500 focus-visible:outline-offset-2"
            />
        </label>
    );
}
